import axios from 'axios'

const app = 'MMR'
//const app = 'KIT'
const url = 'http://localhost:5000/'

const getMode = () => {
  if (location.host === 'localhost:8888') {
    return true
  }
  return false
}

const getDefinitions = async () => {
  return JSON.stringify([
    {
      application: app, label: 'application',
      meaning: {
        ja: 'localtest'
      },
      type: 'application'
    },
    {
      application: app, label: 'route',
      meaning: {
        first: '/' + app + '/list'
      },
      type: 'route'
    }

  ])
}

const getMeasurement = async (params, variables) => {
  let a = await axios({
    method: 'GET',
    url: url + 'measurement/',
    params: {
      id: variables,
      application: app
    },
    headers: { 'Access-Control-Allow-Origin': '*', }
  })
  return a.data
}

const getUser = () => {
  return {
    user: {
      'username': 'localuser'
    },
    session: {
      'idToken': {
        'jwtToken': 'eyJraWQiOiJIWkJKekVneENIbjRDVjFTZ3FHVE16Smo0RndKellTbXdaNVZFU0tOcmpRPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI3NGNhNTg3Yy02NTljLTRhYTktYTM1Yi1iNmUzZmE2ZDkxOTgiLCJlbWFpbF92ZXJpZmllZCI6ZmFsc2UsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC5hcC1ub3J0aGVhc3QtMS5hbWF6b25hd3MuY29tXC9hcC1ub3J0aGVhc3QtMV9rSlZWNUVLRm0iLCJjb2duaXRvOnVzZXJuYW1lIjoidXNlcjAzIiwiY3VzdG9tOmFwcGxpY2F0aW9uIjoiS00iLCJhdWQiOiI3Y2doc280MHM5YzFrNGJnc2xpZnRndmI1ciIsImV2ZW50X2lkIjoiZjZlNTAxODMtZTBkMS0xMWU4LTlmMTMtYmI3YjYzNWEwYTE5IiwiY3VzdG9tOnJpZ2h0cyI6ImFkbWluIiwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE1NDE0MDUzMDMsImV4cCI6MTU0MTQwODkwMywiaWF0IjoxNTQxNDA1MzAzLCJlbWFpbCI6Imhpcm9uYW8ubmFtYmFAa29uaWNhbWlub2x0YS5jb20ifQ.N1vdV1dhPKe0KqRkfogLFNHsJfCstwnmq0dACJwm3pX6ydlei6eS7WfC_QZF2JI7apex6Bgdd6fCyZKSTON5mXYLnLirEclJOFmpCnt0wWFHo-3FGyh8c8xeX937N6D5OBJx9tuRhIHr6y-RhCyaC5KXB7XSKJhcQQcniBpnBfotMlTFx3wmJ19Mzypaf3JeMdrYbDruVTPTCPYgVWy1LzyBug5-njuX6XSDjsBEQMrFL-Mx-tCYOflh3k91D-KepdL5VZjdAdn6lQx8J8VxyiZNmr9utx4QFo_J2WOry82gjnctxJMI0l33OnEliF090tjVVkBjUZAd64UBb7daxw'
      }
    },
    attribute: {
      'custom:application': app,
      'custom:rights': 'admin',
      'email': 'abc@aca'
    }
  }
}

const getProjects = () => {
  return []
}
const getTags = () => {
  return '[]'
}

const getMeasurements = async (params, variables) => {

  let a = await axios({
    method: 'GET',
    url: url + 'measurements/',
    params: {
      from: params.body.from,
      to: params.body.to,
      key: params.body.lastEvaluatedKey,
      application: app
    },
    headers: { 'Access-Control-Allow-Origin': '*' }
  })
  return a.data
}

const getResultset = async (params, variables) => {
  let a = await axios({
    method: 'GET',
    url: url + 'resultsets/',
    params: {
      id: variables,
      application: app
    },
    headers: { 'Access-Control-Allow-Origin': '*' }
  })
  return a.data
}


const call = async (api, params, variables) => {
  if (api === 'getDefinitions') {
    return await getDefinitions()

  } else if (api === 'getMeasurementWithId') {
    return await getMeasurement(params, variables)

  } else if (api === 'getResultSets') {
    return await getResultset(params, variables)

  } else if (api === 'getProjects') {
    return await getProjects()

  } else if (api === 'getTags') {
    return await getTags()

  } else if (api === 'getMeasurements') {
    return await getMeasurements(params, variables)

  } else if (api === 'user') {
    return getUser()

  } else {
    console.log('no such API:' + api)
    console.log(params)
  }
}

export default {
  getMode,
  call
}

process.env.PORT = 8888
